module.exports = __webpack_public_path__ + "img/Gav.af9d3064.jpeg";